export default __webpack_public_path__ + "static/media/42_desktop.d0051d63.jpg";